import { remove } from 'lodash'

export default class AgesFilter {
  constructor () {
    this._dropdown = document.getElementById('ages-filter-dropdown')
    this._buttonList = document.querySelectorAll('.ages')
    this._removeAllButton = document.querySelector('.remove-all-filter')
    this._filter = document.querySelector('#ages-filter')
    this._label = document.querySelector('.ages-label')
    this._count = document.querySelector('#ages-filter-count')
    this._events = {
      ageButtons: [],
      removeButton: null
    }
    this.filter = { ages: [] }

    if (this._filter) {
      this._filter.addEventListener('click', this._toggleDropdown.bind(this))
    } else {
      this._buttonList.forEach((element, index) => {
        const boundClick = this._handleAgeSelection.bind(this, element)
        this._events.ageButtons.push(boundClick)
        element.addEventListener('click', boundClick)
      })
      this._events.removeButton = this._handleRemoveAgeSelection.bind(this)
      this._removeAllButton.addEventListener('click', this._events.removeButton)
    }
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:agesFilter:change',
      OPEN: 'poin:agesFilter:open',
      CLOSE: 'poin:agesFilter:close'
    }
  }

  async init () {
    const queryParams = new URLSearchParams(window.location.search)
    const ages = queryParams.get('ages')

    if (ages) {
      this.filter.ages = ages.match(/\d+,\d+/g)

      this._buttonList.forEach((element) => {
        if (this.filter.ages.includes(element.getAttribute('data-value'))) {
          element.classList.add('selected')
        }
      })
      this._updateAgeFilterCount()
    }
  }

  _toggleDropdown () {
    if (this._dropdown.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this._dispatchEvent(AgesFilter.EVENT.OPEN)
    this._dropdown.classList.remove('hidden')
    const viewportWidth = document.documentElement.clientWidth
    const horizontalDisplacement = this._filter.offsetLeft - this._dropdown.offsetLeft - this._filter.parentElement.scrollLeft
    const verticalDisplacement = this._filter.offsetTop - this._dropdown.offsetTop + this._filter.offsetHeight + 5

    this._buttonList.forEach((element) => {
      const boundFunction = this._handleAgeSelection.bind(this, element)
      this._events.ageButtons.push(boundFunction)
      element.addEventListener('click', boundFunction)
    })
    this._events.removeButton = this._handleRemoveAgeSelection.bind(this)
    this._removeAllButton.addEventListener('click', this._events.removeButton)
    // translate the dropdown position relative to the filter position
    this._dropdown.style.transform = `translate(${horizontalDisplacement}px, ${verticalDisplacement}px)`

    if (this._dropdown.getBoundingClientRect().right > viewportWidth) { // additional displacement to prevent exceeding viewport width
      const additionalHorizontalOffset = this._dropdown.getBoundingClientRect().right - viewportWidth + 5
      this._dropdown.style.transform = `translate(${horizontalDisplacement - additionalHorizontalOffset}px, ${verticalDisplacement}px)`
    } else if (this._dropdown.getBoundingClientRect().left < 0) {
      this._dropdown.style.transform = `translate(5px, ${verticalDisplacement}px)`
    }
  }

  close () {
    this._dispatchEvent(AgesFilter.EVENT.CLOSE)
    this._dropdown.style.removeProperty('transform')
    this._dropdown.classList.add('hidden')
    this._buttonList.forEach((element, index) => {
      element.removeEventListener('click', this._events.ageButtons[index])
    })
    this._events.ageButtons = []
    this._removeAllButton.removeEventListener('click', this._events.removeButton)
    this._events.removeButton = null
  }

  /**
   * @param {HTMLElement} element
   * @param {Event} event
   */
  _handleAgeSelection (element, event) {
    event.stopImmediatePropagation()
    const ageRange = element.getAttribute('data-value')

    if (this.filter.ages.includes(ageRange)) {
      remove(this.filter.ages, (element) => element === ageRange)
      element.classList.remove('selected')
    } else {
      this.filter.ages.push(ageRange)
      element.classList.add('selected')
    }

    this._dispatchEvent(AgesFilter.EVENT.CHANGE)
    this._updateAgeFilterCount()
  }

  /**
   * @param {Event} event
   */
  _handleRemoveAgeSelection (event) {
    event.stopImmediatePropagation()
    this.clean()
  }

  clean () {
    document.querySelectorAll('.ages').forEach((element) => { element.classList.remove('selected') })
    this.filter.ages = []

    this._dispatchEvent(AgesFilter.EVENT.CHANGE)
    this._updateAgeFilterCount()
  }

  _updateAgeFilterCount () {
    if (this._count) {
      if (this.filter.ages.length) {
        this._count.classList.remove('hidden')
        this._label.style.paddingRight = '0px'
      } else {
        this._count.classList.add('hidden')
        this._label.style.paddingRight = '24px'
      }
    }
  }

  _dispatchEvent (event) {
    const _event = new Event(event, { bubbles: true })

    if (this._filter) {
      this._filter.dispatchEvent(_event)
    } else {
      this._dropdown.dispatchEvent(_event)
    }
  }

  filterIsSet () {
    return Boolean(this.filter.ages.length)
  }
}
